import Backbone from 'backbone';
import ko from 'knockout';
import _ from 'underscore';

import { formatDecimal } from '@bingads-webui-campaign/recommendation-core';

import ViewModel from './bid-editor-model';
import template from './bid-editor.pug';

export class BidEditorView extends Backbone.View {
  initialize({
    i18n,
    suggestedBidField,
    item,
    key,
    view,
    appConfig,
    jsdata,
    edmCampaign,
    isMCC,
    newI18n,
    recommendationType,
  }) {
    this.i18n = i18n;
    this.item = item;
    this.key = key;
    this.view = view;
    this.appConfig = appConfig;
    this.jsdata = jsdata;
    this.edmCampaign = edmCampaign;
    this.isMCC = isMCC;
    this.newI18n = newI18n;
    this.recommendationType = recommendationType;
    this.isKeywordBid = true;
    this.adGroupBidVal = '';
    // Get MT suggested bid as the default value and localize this bid.
    const suggestedBid = _.chain(item.Opportunities).first().result('NewBid').value()
      || _.chain(item.Opportunities).first().result(suggestedBidField).value();
    const formatSuggestedBid = formatDecimal(suggestedBid, i18n);
    this.viewModel = new ViewModel({
      i18n,
      formatSuggestedBid,
      appConfig,
      newI18n,
      recommendationType,
      suggestedBid,
    });
  }

  get events() {
    return {
      'click .save': 'save',
      'click .cancel': 'cancel',
      'click .use_adgroup_bid': 'useAdGroupBid',
      'click .use_keyword_bid': 'useKeywordBid',
    };
  }

  save() {
    const {
      isKeywordBid, adGroupBidVal, item, key, view, i18n,
    } = this;

    if (!this.isBidValid()) { return; }

    const bidValue = isKeywordBid ?
      i18n.parseDecimal(this.viewModel.userInputDisplayVal()) :
      Number(adGroupBidVal);

    if (_.isNaN(bidValue)) {
      return;
    }

    // Update bid value in grid.
    _.first(item.Opportunities).NewBid = bidValue;

    const selectedKeys = view.grid.gridView.selectedKeys();
    // Append the current selected one into existing selected ones.
    if (!_.contains(selectedKeys, key)) {
      selectedKeys.push(key);
    }
    view.grid.gridView.set({ selection: _.defaults({ selected: selectedKeys }) });

    this.trigger('close');
  }

  cancel() {
    this.trigger('close');
  }

  isBidValid() {
    const {
      isKeywordBid, adGroupBidVal, appConfig, i18n,
    } = this;

    if (isKeywordBid) {
      const keywordBidValue = i18n.parseDecimal(this.viewModel.userInputDisplayVal());
      if (_.isNaN(keywordBidValue)) { return false; }

      if (keywordBidValue < appConfig.get('KeywordBidRange').FloorValue ||
        keywordBidValue > appConfig.get('KeywordBidRange').CeilingValue) {
        return false;
      }
    }

    if (!isKeywordBid && !_.isNumber(adGroupBidVal)) {
      return false;
    }

    return true;
  }

  updateKeywordAdGroupBid() {
    const {
      isKeywordBid, jsdata, item, i18n, edmCampaign, isMCC,
    } = this;
    const keywordLink = this.$el.find('.use_keyword_bid');
    const adgroupLink = this.$el.find('.use_adgroup_bid');
    const inputBox = this.$el.find('.bid-textbox');
    const adgroupSpan = this.$el.find('.adgroup_bid_value_span');
    const errorMessage = this.$el.find('.error-message');
    const warningMessage = this.$el.find('.warning-message-container');
    const adGroupId = _.first(item.Opportunities).NewAdGroupId || item.Target.AdGroupId;
    const accountId = item.Target.AccountId;
    const options = isMCC ?
      {
        entitySet:
          edmCampaign
            .currentCustomer
            .Accounts
            .$withKey(Number(accountId))
            .AdGroups,
      } : {};

    if (isKeywordBid) {
      keywordLink.addClass('keywordSelectedSelection');
      adgroupLink.removeClass('keywordSelectedSelection');
      inputBox.show();
      adgroupSpan.hide();
      errorMessage.show();
      warningMessage.show();
    } else {
      jsdata.AdGroup.findAll({
        limit: 1,
        select: ['Id', 'SearchBid'],
        where: { Id: { $eq: adGroupId } },
      }, options).then((response) => {
        if (response.length && response.length > 0) {
          this.adGroupBidVal = response[0].SearchBid;
        }
        keywordLink.removeClass('keywordSelectedSelection');
        adgroupLink.addClass('keywordSelectedSelection');
        inputBox.hide();
        const adGroupBid = formatDecimal(this.adGroupBidVal, i18n);
        adgroupSpan.html(`${adGroupBid}`);
        adgroupSpan.show();
        errorMessage.hide();
        warningMessage.hide();
      });
    }
  }

  useAdGroupBid() {
    this.isKeywordBid = false;
    this.updateKeywordAdGroupBid();
  }

  useKeywordBid() {
    this.isKeywordBid = true;
    this.updateKeywordAdGroupBid();
  }

  render() {
    const { i18n, adGroupBidVal } = this;
    this.$el.html(template({
      i18n,
      adGroupBidVal,
    }));
    ko.applyBindings(this.viewModel, this.el);
    const adgroupSpan = this.$el.find('.adgroup_bid_value_span');
    adgroupSpan.hide();
    return this;
  }
}
